export default __webpack_public_path__ + "0691e5d935e4ac75f929806022c4ccb0.svg";